module.exports = __webpack_public_path__ + "src/assets/img/page8/2f23c964ea7008e639194d6ef9d85f90.jpg";